import styles from './myReviews.module.css';
import MyReview from './Components/ReviewBlock.jsx';
import ReviewPopup from '../components/reviewPopup/reviewPopup.jsx';
import { memo, useEffect, useState } from 'react';
import { getGoogleHotel, getHotelsByIds, getReviewsData } from '../services/api.js';
import Loading from '../components/Loading/Loading.jsx';

const MyReviewsPage = () => {
  const [reviewEditPopup, setreviewEditPopup] = useState(false);
  const [reviewCards, setReviewCards] = useState([]);
  const [hotelID, setHotelID] = useState(null);
  const [googlePlaceId, setGooglePlaceId] = useState(null);
  const [myReviews, setMyReviews] = useState();
  const [hotelReview, setHotelReview] = useState({})
  const [refreshReviews, setRefreshReviews] = useState(false);
  const [loading, setLoading] = useState({ edit: false, update: false })
  useEffect(() => {
    async function getHotels() {
      let getMyReviews = await getReviewsData(null, 'userReview')
      const localHotelIds = (getMyReviews || []).map(review => review.hotelID).filter(Boolean);
      let allHotels = await getHotelsByIds(localHotelIds)
      const localReviewCards = allHotels
        .filter(hotel => getMyReviews?.some(review => review.hotelID === hotel.id))
        .map(hotel => ({
          hotel,
          review: getMyReviews.find(review => review.hotelID === hotel.id) || "",
        }));
      const googlePlaceIds = [...new Set((getMyReviews || []).map(review => review.googlePlaceId).filter(Boolean))];
      const googleHotels = await Promise.all(
        googlePlaceIds.map(async (placeId) => {
          const hotel = await getGoogleHotel(placeId);
          return hotel?.error ? null : hotel;
        })
      );
      const googleReviewCards = googleHotels
        .filter(Boolean)
        .map(hotel => ({
          hotel,
          review: getMyReviews.find(review => review.googlePlaceId === hotel.placeId) || "",
        }));

      setMyReviews(getMyReviews)
      setReviewCards([...localReviewCards, ...googleReviewCards])
      setLoading(prev => ({ ...prev, update: false }))
    }
    getHotels()
  }, [refreshReviews, hotelID, googlePlaceId]);

  useEffect(() => {
    async function getHotels() {
      if (!hotelID && !googlePlaceId) {
        setHotelReview({});
        setLoading(prev => ({ ...prev, edit: false }))
        return;
      }

      let getHotelReview = await getReviewsData(hotelID, 'userReview', googlePlaceId)
      if(getHotelReview) setHotelReview(getHotelReview[0])
      setLoading(prev => ({ ...prev, edit: false }))
    }
    getHotels()
  }, [hotelID, googlePlaceId, reviewEditPopup]);

  return (
    myReviews ? <>
      <div className={styles.overlay} style={{ display: reviewEditPopup ? 'block' : 'none' }}></div>
      <ReviewPopup
        reviewEditPopup={reviewEditPopup}
        hotelReviewData={hotelReview}
        closePopup={() => setreviewEditPopup(false)}
        googlePlaceId={googlePlaceId}
        setRefreshReviews={setRefreshReviews}
        loading={loading}
        setLoading={setLoading}
      />
      <div className={styles.page_wrapper}>
        <h1 className={styles.title}>My Reviews</h1>
        <div className={styles.reviews_inner}>
          {
            reviewCards?.length > 0 && !loading.update ? reviewCards.map(({ hotel, review }) => (
              <MyReview key={hotel.id || hotel.placeId} hotel={hotel} triggerReviewEditPopup={() => {
                setreviewEditPopup(true)
                setLoading(prev => ({ ...prev, edit: true }))
              }}
                hotelData={{ hotel, review }}
                setHotelID={setHotelID}
                setGooglePlaceId={setGooglePlaceId}
                loading={loading}
              />
            )) : loading.update ? <Loading style={{ marginTop: '80px' }} type='SyncLoader' /> : <p style={{textAlign:"center" , fontSize:"1.2rem" , color:'#662d918a'}}>You don’t have any reviews yet.</p>
          }
        </div>
      </div>
    </> : <Loading />
  );
};

export default memo(MyReviewsPage); 
